import React from "react";
import "./style.css";

function Footer() {
  return (
    <section className="copyright">
      <div className="container">
        <p> Lois Aleghe &copy; 2021</p>
      </div>
    </section>
  );
}

export default Footer;
